export const getCreditViewSettings = tenbisCreditConversion => {
  const showAutoCredit =
    tenbisCreditConversion?.isEnabled &&
    tenbisCreditConversion.tenbisCreditSettings &&
    !tenbisCreditConversion.tenbisCreditSettings.disableAutoCreditOption;

  const showManualCreditLoad =
    tenbisCreditConversion?.isEnabled &&
    (!tenbisCreditConversion.tenbisCreditSettings || tenbisCreditConversion.tenbisCreditSettings.isManualLoadAllowed);

  const isAutoCreditActive = tenbisCreditConversion?.tenbisCreditSettings?.autoCreditSubscribed;
  
  return {showAutoCredit, showManualCreditLoad, isAutoCreditActive};
};
